import { Controller, useFormContext } from "react-hook-form"
import { useTranslation } from "react-i18next"
import { FormError } from "@/components/ui/form"
import { RadioGroup, RadioGroupItem, RadioGroupLabel } from "@/components/ui/radio-group"
import { useResetDependentAnswers } from "@/modules/patients/detail/better-doc/de/components/better-doc-consultation-questionnaire/useResetDependentAnswers"
import {
  type BetterDocConsultationQuestionId,
  YES_NO_OPTIONS,
} from "@/modules/patients/detail/better-doc/de/lib/better-doc-consultation-questionnaire-definition"
import { getQuestionTestIdPrefix } from "@/modules/patients/detail/better-doc/de/lib/better-doc-consultation-questionnaire-test-ids"
import type { DeBetterDocSearchFormType } from "@/modules/patients/detail/better-doc/de/schema/de-better-doc-search-schema"

export const BetterDocQuestionnaireYesNoField = ({ questionId }: { questionId: BetterDocConsultationQuestionId }) => {
  const { t } = useTranslation()
  const { control } = useFormContext<DeBetterDocSearchFormType>()

  const resetDependentAnswers = useResetDependentAnswers(questionId)

  const testIdPrefix = getQuestionTestIdPrefix(questionId)

  return (
    <div className="flex w-full flex-col gap-2">
      <div className="text-on-surface text-sm leading-5" data-testid={`${testIdPrefix}-label`}>
        {t(`episodeOfCare.betterDoc.searchDialog.consultationQuestionnaire.${questionId}.label`)}*
      </div>
      <Controller
        control={control}
        name={questionId}
        render={({ field: { value, onChange }, fieldState: { error } }) => (
          <>
            <RadioGroup
              className="flex"
              value={value ?? ""}
              onValueChange={(nextAnswer) => {
                onChange(nextAnswer)
                resetDependentAnswers()
              }}>
              {YES_NO_OPTIONS.map((option) => (
                <RadioGroupItem key={option} value={option} data-testid={`${testIdPrefix}-option-${option}`}>
                  <RadioGroupLabel>{t(`common.${option}`)}</RadioGroupLabel>
                </RadioGroupItem>
              ))}
            </RadioGroup>
            {error?.message && <FormError>{t(error.message)}</FormError>}
          </>
        )}
      />
    </div>
  )
}
